import ConfigProvider from './configProvider'
import compDefaultProps from './compDefaultProps'
import ConfigContext from './ConfigContext'
import defaultConfig from './defaultConfig'
export { compDefaultProps, ConfigContext, defaultConfig }
export default ConfigProvider
